import { Copy07Icon } from '@/components/icons/Copy07Icon';
import { useFeedback } from '@/components/notifications/Feedback/useFeedback';
import { MenuItem } from '@/components/poppers/MenuPopper/MenuItem';
import { useReportError } from '@/hooks/useReportError';
import { useCanEditHouseholdData } from '@/modules/authentication/hooks/useCanEditHouseholdData';

import { useDuplicateCashflowMutation } from './graphql/DuplicateCashflowMenuItem.generated';

interface DuplicateCashflowMenuItemProps {
  cashflowId: string;
  onDuplicate: () => void;
}

export function DuplicateCashflowMenuItem({
  cashflowId,
  onDuplicate,
}: DuplicateCashflowMenuItemProps) {
  const canEdit = useCanEditHouseholdData();
  const { showFeedback } = useFeedback();
  const { reportError } = useReportError();

  const [duplicateCashflow, { loading }] = useDuplicateCashflowMutation({
    variables: { cashflowID: cashflowId },
    onError: (error) => {
      reportError('Failed to duplicate cashflow', error);
      showFeedback(
        'Failed to duplicate this cash flow. Please refresh the page and try again.'
      );
    },
    onCompleted: () => {
      showFeedback('Cash flow duplicated successfully', {
        variant: 'success',
      });
      onDuplicate();
    },
  });

  if (!canEdit) {
    return null;
  }

  return (
    <MenuItem
      label="Duplicate"
      icon={<Copy07Icon size={16} />}
      loading={loading}
      onClick={() => duplicateCashflow()}
    />
  );
}
